import type { AccessoryVitrineTile } from '../api'

type Variant = AccessoryVitrineTile['variants'][number]

/** Одна логика для плитки и модалки: hero главный, фото варианта — только при смене цвета. */
export function resolveVitrineTileImage(
  tile: AccessoryVitrineTile,
  opts?: { variant?: Variant | null; colorSelected?: boolean },
): string {
  const hero = (tile.hero_image_url || '').trim()
  const vImg = (opts?.variant?.image_url || '').trim()
  if (opts?.colorSelected && vImg) return vImg
  if (hero) return hero
  if (vImg) return vImg
  return (tile.variants.find((v) => v.image_url)?.image_url || '').trim()
}
